export async function fetchAnalytes(submissionId) {
    console.log("fetching analytes for submission " + submissionId)
    let response = await fetch(`/submissions/${submissionId}/analytes`)
    let data = await response.json()
    console.log(data)
    return data

    // return ["Choline", "Thymine", "Indole"]
}


export async function fetchAnalyteData(submissionId, analyte) {
    console.log("fetching analyte data for " + analyte)
    const response = await fetch(`/submissions/${submissionId}/analyte_samples?analyte=${analyte}`)
    const data = await response.json()
    console.log(data)
    return data
}


export async function fetchSampleChromatogram(submissionId, analyteId, sampleId) {
    return fetch(`/submissions/${submissionId}/get_analyte_chromatogram_data?analyte_id=${analyteId}&sample_id=${sampleId}`)
        .then((response) => response.json())
        .then((data) => {
            console.log(`chromatogram data fetched for ${analyteId}, ${sampleId}: `, data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING CHROMATOGRAM DATA:\n", error)
            return []
        })
        
}


export async function fetchSubmissions() {
    // [
    //     Project_Name => [
    //         Assay => [
    //             { Submission 1 },
    //         ]
    //     ]
    // ]
    console.log("fetching submissions...")
    const response = await fetch(`/get_all_submissions`)
    let data = await response.json()
    // data.forEach((sub, idx) => {
    //     let kits;

    // })
    console.log(data)
    return data
}

let nestedData = [
    {id:1, project_name: "MTX Samples", date_created: "2021-01-01", kits:[
        {kit_name:"MEGA Kit", eachSubmission:[
            {panel:"MEGA A", status:"Submitted", progress: 20, biofluid:"Serum", spectra_number: 23, date_created: new Date("2021-01-01")},
            {panel:"MEGA B", status:"Preprocessing", progress: 40, biofluid:"Serum", spectra_number: 3, date_created: new Date("2021-01-02")},
        ]},
        {kit_name:"PRIME Kit", eachSubmission:[
            {panel:"PRIME A", status:"Preprocessed", progress: 60, biofluid:"Serum", spectra_number: 123, date_created: new Date("2021-01-02")},
            {panel:"PRIME B", status:"Profiling", progress: 80, biofluid:"Blood", spectra_number: 23, date_created: new Date("2021-01-02")},
        ]},
    ]},
    {id:2, project_name: "TMIC Client#45 Samples", date_created: "2020-01-01", kits:[
        {kit_name:"PRIME Kit", eachSubmission:[
            {panel:"FIA Positive", status:"Profiled", progress: 100, biofluid:"Fecal", spectra_number: 123, date_created: new Date("2021-01-02")},
            {panel:"FIA Negative", status:"Profiled", progress: 100, biofluid:"Fecal", spectra_number: 12, date_created: new Date("2021-01-02")},
        ]},
    ]},
]


export async function fetchCalibrationCurve(submissionId, analyte) {
    const response = await fetch(`/submissions/${submissionId}/get_calibration_curve?analyte=${analyte}`)
    const data = await response.json()
    console.log(data)
    return data
}








// Refactored End Points

export async function fetchAllSubmissions() {
    // returns the nested data structure for the submissions index table
    return fetch("/get_all_submissions")
        .then((response) => response.json())
        .then((data) => {
            console.log("all submissions fetched: ", data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING ALL SUBMISSIONS:\n", error)
            return []
        })
}


export async function fetchSubmissionRows() {
    // simply returns the submission rows
    return fetch("/get_submission_rows")
        .then((response) => response.json())
        .then((data) => {
            console.log("submission rows fetched: ", data)
            return data
        })
}

export async function fetchSubmission(submissionId) {
    // returns a single submission object
    // - used for populating index table
    // - used for polling submission status
    return fetch(`/submissions/${submissionId}/get_submission_metadata`)
        .then((response) => response.json())
        .then((data) => {
            console.log("submission fetched: ", data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING SUBMISSION:\n", error)
            return {}
        })
}

export async function fetchAllAnalytes(submissionId) {
    // returns a list of all analyte like [[analyteId, analyteName], [analyteId, analyteName], ...] from the Analyte model
    return fetch(`/submissions/${submissionId}/get_all_analytes`)
        .then((response) => response.json())
        .then((data) => {
            console.log("returning all analytes fetched: ", data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING ALL ANALYTES:\n", error)
            return []
        })
}

export async function fetchSampleFlags(submissionId) {
    // returns a list of all sample flags from the SampleFlags model
    return fetch(`/submissions/${submissionId}/get_all_sample_flags`)
        .then((response) => response.json())
        .then((data) => {
            console.log("sample flags fetched: ", data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING SAMPLE FLAGS:\n", error)
            return []
        })
}

export async function fetchCleanFlags(submissionId) {
    // returns a list of all clean flags from the CleanFlags model
    return fetch(`/submissions/${submissionId}/get_clean_flags`)
        .then((response) => response.json())
        .then((data) => {
            console.log("clean flags fetched: ", data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING CLEAN FLAGS:\n", error)
            return []
        })
}

export async function fetchAnalyteSampleTableData(submissionId, analyteId, analyteName) {
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/get_sample_data?analyte_id=${analyteId}&analyte_name=${analyteName}`)
        .then((response) => response.json())
        .then((data) => {
            console.log(`analyte sample data fetched for ${analyteId}, ${analyteName}: `, data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING ANALYTE SAMPLE DATA:\n", error)
            return []
        })
    
}



export async function fetchAnalyteCalibrationCurveData(submissionId, analyteId, analyteName) {
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/get_calibration_curve_data?analyte_id=${analyteId}&analyte_name=${analyteName}`)
        .then((response) => response.json())
        .then((data) => {
            console.log(`analyte calcurve data fetched for ${analyteId}, ${analyteName}: `, data)
            // data['cal_points'] = JSON.parse(data['cal_points'])
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING ANALYTE CALIBRATION CURVE DATA:\n", error)
            return []
        })
}


export async function startProfiling(submissionId) {
    return fetch(`/submissions/${submissionId}/start_profiling`)
        .then((response) => response.json())
        .then((data) => {
            console.log(`started profiling for ${submissionId}`, data)
            return data
        })
        .catch((error) => {
            console.error("ERROR STARTING PROFILING:\n", error)
            return []
        })
}

export async function resetCalPoints(submissionId, applyToAllAnalytes, analyteName, analyteId) {
    console.log("resetting cal points...", submissionId, applyToAllAnalytes, analyteName)
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/reset_cal_points?apply_to_all_analytes=${applyToAllAnalytes}&analyte_name=${analyteName}&analyte_id=${analyteId}`)
        .then((response) => response.json())
        .then((data) => {
            console.log(`reset cal points for ${submissionId}`, data)
            return data
        })
        .catch((error) => {
            console.error("ERROR RESETTING CAL POINTS:\n", error)
            return []
        })
}

export async function recalibrateAnalyte(submissionId, analyteId, analyteName, pointStates, applyToAllAnalytes) {
    analyteName = encodeURIComponent(analyteName)
    console.log("recalibrating analyte...", submissionId, analyteId, analyteName, pointStates, applyToAllAnalytes)
    return fetch(`/submissions/${submissionId}/recalibrate_analyte?analyte_id=${analyteId}&analyte_name=${analyteName}&point_states=${pointStates}&apply_to_all_analytes=${applyToAllAnalytes}`)
    .then((response) => response.json())
    .then((data) => {
        console.log(`recalibrated analyte ${analyteId}, ${analyteName}`, data)
        return data
    })
    .catch((error) => {
        console.error("ERROR RECALIBRATING ANALYTE:\n", error)
        return []
    })
}



export async function recalculatePeakAreasFIA(submissionId, analyteId, analyteName, newRetentionWindow) {
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/recalculate_peak_areas?analyte_id=${analyteId}&analyte_name=${analyteName}&new_retention_window=${newRetentionWindow}`)
    .then((response) => response.json())
    .then((data) => {
        console.log(`recalculated peak areas for ${analyteId}, ${analyteName}: `, data)
        return data
    })
    .catch((error) => {
        console.error("ERROR RECALCULATING PEAK AREAS:\n", error)
        return []
    })
}

export async function recalculatePeakAreasLC(submissionId, analyteId, analyteName, rtmin_analyte, rtmax_analyte, rtmin_istd, rtmax_istd, applyNewRtToAllSamples, sampleId, analyteOrISTD, applyBCToAllSamples, calPointStates) {
    // console.log("recalculating peak areas for LC...", submissionId, analyteId, analyteName, rtmin_analyte, rtmax_analyte, rtmin_istd, rtmax_istd, applyNewRtToAllSamples, sampleId, analyteOrISTD, apapplyBCToAllSamplesplyBCToAnalyte)
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/recalculate_peak_areas?analyte_id=${analyteId}&analyte_name=${analyteName}&rtmin_analyte=${rtmin_analyte}&rtmax_analyte=${rtmax_analyte}&rtmin_istd=${rtmin_istd}&rtmax_istd=${rtmax_istd}&apply_new_rt_to_all_samples=${applyNewRtToAllSamples}&sample_id=${sampleId}&analyte_or_istd=${analyteOrISTD}&apply_baseline_to_all_samples=${applyBCToAllSamples}&cal_selected=${calPointStates}`)
    .then((response) => response.json())
    .then((data) => {
        console.log(`recalculated peak areas for ${analyteId}, ${analyteName}: `, data)
        return data
    })
    .catch((error) => {
        console.error("ERROR RECALCULATING PEAK AREAS:\n", error)
        return []
    })
}


export async function applyNewRtWindow(submissionId, analyteId, analyteName, applyToAnalyte, applyToISTD, applyNewRtToAllSamples, sampleFileID, analyteWindow, istdWindow) {
    console.log("applying new rt window...", submissionId, analyteId, analyteName, applyToAnalyte, applyToISTD, applyNewRtToAllSamples, sampleFileID, analyteWindow, istdWindow)
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/apply_new_rt_window?analyte_id=${analyteId}&analyte_name=${analyteName}&apply_to_analyte=${applyToAnalyte}&apply_to_istd=${applyToISTD}&apply_new_rt_to_all_samples=${applyNewRtToAllSamples}&sample_id=${sampleFileID}&analyte_window=${analyteWindow}&istd_window=${istdWindow}`)
    .then((response) => response.json())
    .then((data) => {
        console.log(`applied new rt window for ${analyteId}, ${analyteName}: `, data)
        return data
    })
    .catch((error) => {
        console.error("ERROR APPLYING NEW RT WINDOW:\n", error)
        return []
    })
}
    
    
export async function applyBaselineCorrection(submissionId, analyteId, analyteName, applyToAnalyte, applyToISTD, applyBCToAllSamples, sampleFileID, calPointStatesString, ){
    console.log("applying baseline correction...", submissionId, analyteId, analyteName, applyToAnalyte, applyToISTD, applyBCToAllSamples, sampleFileID, calPointStatesString)
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/apply_baseline_correction?analyte_id=${analyteId}&analyte_name=${analyteName}&apply_to_analyte=${applyToAnalyte}&apply_to_istd=${applyToISTD}&apply_baseline_corr_to_all_samples=${applyBCToAllSamples}&sample_file=${sampleFileID}&cal_point_states=${calPointStatesString}`)
    .then((response) => response.json())
    .then((data) => {
        console.log(`applied baseline correction for ${analyteId}, ${analyteName}: `, data)
        return data
        })
        .catch((error) => {
            console.error("ERROR APPLYING BASELINE CORRECTION:\n", error)
            return []
        })
    }
    
    
export async function fetchProfilingStatus(submissionId, analyteId, analyteName) {
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/get_profiling_status?analyte_id=${analyteId}&analyte_name=${analyteName}`)
    .then((response) => response.json())
    .then((data) => {
        console.log(`profiling status for ${analyteId}, ${analyteName}: `, data)
        return data
    })
    .catch((error) => {
        console.error("ERROR FETCHING PROFILING STATUS:\n", error)
        return []
    })
}



export async function fetchRecalibrationStatus(submissionId, analyteId, analyteName, sampleId) {
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/get_recalibration_status?analyte_id=${analyteId}&analyte_name=${analyteName}&sample_id=${sampleId}`)
        .then((response) => response.json())
        .then((data) => {
            console.log(`recalibration status for ${analyteId}, ${analyteName}, [sampleId: ${sampleId}]: `, data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING RECALIBRATION STATUS:\n", error)
            return []
        })
}



export async function fetchSubmissionStatus(submissionId) {
    return fetch(`/submissions/${submissionId}/get_submission_status`)
        .then((response) => response.json())
        .then((data) => {
            // console.log(`submission status for ${submissionId}: `, data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING SUBMISSION STATUS:\n", error)
            return []
        })
}



export async function fetchKitRegistrationsForUser() {
    return fetch(`/get_kit_registrations`)
        .then((response) => response.json())
        .then((data) => {
            console.log("kit registrations for user fetched: ", data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING KIT REGISTRATIONS FOR USER:\n", error)
            return []
        })
}




export async function fetchSubmissionsForKitRegistration(kitRegistrationId) {
    return fetch(`/get_submissions_for_kit_registration?kit_registration_id=${kitRegistrationId}`)
        .then((response) => response.json())
        .then((data) => {
            console.log(`submissions for kit registration ${kitRegistrationId} fetched: `, data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING SUBMISSIONS FOR KIT REGISTRATION:\n", error)
            return []
        })
}


export async function fetchKitData(kitRegistrationId) {
    return fetch(`/get_kit_metadata?kit_registration_id=${kitRegistrationId}`)
        .then((response) => response.json())
        .then((data) => {
            console.log(`submissions for kit registration ${kitRegistrationId} fetched: `, data)
            return data
        })
        .catch((error) => {
            console.error("ERROR FETCHING SUBMISSIONS FOR KIT REGISTRATION:\n", error)
            return []
        })
}



export async function downloadRTTemplate(selectedPanel) {
    console.log('fetching rt template for panel: ', selectedPanel)
    return fetch(`/download_rt_template?selected_panel=${selectedPanel}`)
        .catch((error) => {
            console.error("ERROR DOWNLOADING RT TEMPLATE:\n", error)
            return []
        })
}



//export async function downloadProjectResults(kitRegistrationId, panelASubId, panelBSubId, fia1SubId, fia2SubId, sendToMetaboanalyst) {
    //console.log('fetching project results for kit registration: ', kitRegistrationId)
    //fetch(`/download_project_results?kit_registration_id=${kitRegistrationId}&panel_a_sub_id=${panelASubId}&panel_b_sub_id=${panelBSubId}&fia_1_sub_id=${fia1SubId}&fia_2_sub_id=${fia2SubId}&send_to_metaboanalyst=${sendToMetaboanalyst}`)
    // return fetch(`/download_project_results?kit_registration_id=${kitRegistrationId}&panel_a_sub_id=${panelASubId}&panel_b_sub_id=${panelBSubId}&fia_1_sub_id=${fia1SubId}&fia_2_sub_id=${fia2SubId}&send_to_metaboanalyst=${sendToMetaboanalyst}`)
    //     .then((response) => response.json())
    //     .then((data) => {
    //         console.log(`project results for kit registration ${kitRegistrationId} fetched: `, data)
    //         return data
    //     })
    //     .catch((error) => {
    //         console.error("ERROR DOWNLOADING PROJECT RESULTS:\n", error)
    //         return []
    //     })
//}

export async function downloadProjectResults(kitRegistrationId, panelASubId, panelBSubId, dfi1SubId, dfi2SubId, sendToMetaboanalyst, dfi3SubId=null, dfi4SubId=null, fileFormat='csv') {
    console.log('fetching project results for kit registration: ', kitRegistrationId);
    const response = await fetch(`/download_accuracy_concentration?kit_registration_id=${kitRegistrationId}&panel_a_sub_id=${panelASubId}&panel_b_sub_id=${panelBSubId}&dfi_1_sub_id=${dfi1SubId}&dfi_2_sub_id=${dfi2SubId}&send_to_metaboanalyst=${sendToMetaboanalyst}&dfi_3_sub_id=${dfi3SubId}&dfi_4_sub_id=${dfi4SubId}&file_format=${fileFormat}`);
    
    if (response.ok) {
        // const blob = await response.blob(); // Get the data as a Blob
        // const url = window.URL.createObjectURL(blob); // Create a download link
        // const a = document.createElement('a');
        // a.href = url;
        // a.download = `LC-Autofit-${kitRegistrationId}_result.zip`; // Set the filename
        // document.body.appendChild(a);
        // a.click(); // Trigger the download
        // a.remove(); // Remove the link after downloading
        // return "success"
    } 
    else {
        console.error('Failed to download project concentration and accuracy results:', response.statusText);
        return "error"
    }
}

export async function downloadProjectAllData(kitRegistrationId, panelASubId, panelBSubId, dfi1SubId, dfi2SubId, sendToMetaboanalyst, dfi3SubId=null, dfi4SubId=null, fileFormat='csv') {
    console.log('fetching all project data for kit registration: ', kitRegistrationId);
    // Convert undefined to null string for proper backend handling
    const params = new URLSearchParams({
        kit_registration_id: kitRegistrationId,
        panel_a_sub_id: panelASubId || 'undefined',
        panel_b_sub_id: panelBSubId || 'undefined',
        dfi_1_sub_id: dfi1SubId || 'undefined',
        dfi_2_sub_id: dfi2SubId || 'undefined',
        send_to_metaboanalyst: sendToMetaboanalyst,
        dfi_3_sub_id: dfi3SubId || 'undefined',
        dfi_4_sub_id: dfi4SubId || 'undefined',
        file_format: fileFormat
    });
    const response = await fetch(`/download_project_results?${params.toString()}`);
    if (response.ok){
        // const blob = await response.blob();
        // const url = window.URL.createObjectURL(blob);
        // const a = document.createElement('a');
        // a.href = url;
        // a.download = `LC-Autofit-${kitRegistrationId}_all_data.zip`; // Set the filename
        // document.body.appendChild(a);
        // a.click();
        // a.remove();
        // window.URL.revokeObjectURL(url);
        // return 'success'
    }
    else{
        console.error('Failed to download project all data:', response.statusText);
        const errorText = await response.text();
        console.error('Error details:', errorText);
        alert('Failed to download project data. Please check the console for details.');
        return "error"
    }
}


export async function setLastSelectedSample(submissionId, analyteID, analyteName, sampleFileID) {
    console.log("last selected sample...", submissionId, analyteID, analyteName, sampleFileID)
    analyteName = encodeURIComponent(analyteName)
    return fetch(`/submissions/${submissionId}/last_selected_sample?analyte_id=${analyteID}&analyte_name=${analyteName}&sample_id=${sampleFileID}`)
    .then((response) => response.json())
    .then((data) => {
        console.log(`selected_sample ${sampleFileID}:`, data)
        return data
    })
    .catch((error) => {
        console.error("ERROR SAVING SELECTED SAMPLE:\n", error)
        return []
    })
}


// general util functions
export function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
export function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}